import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Header from './Components/Header';
import './App.css';
import Home from './Components/Home';
import PrivacyPolicy from './Components/PrivacyPolicy';
import DeleteAccount from './Components/DeleteAccount';

function HomeWithSection({ showPopup, setShowPopup }) {
  const location = useLocation();

  useEffect(() => {
    const routeToSection = {
      '/': 'home',
      '/features': 'features',
      '/platform': 'platform',
      '/solutions': 'ai',
      '/technology': 'why',
      '/subscriptions': 'subscriptions',
      '/contact': 'contact',
    };

    const sectionId = routeToSection[location.pathname] || 'home';

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      } else if (sectionId === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return <Home showPopup={showPopup} setShowPopup={setShowPopup} />;
}

function App() {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <Router basename="/">
      <Header onGetStarted={() => setShowPopup(true)} />
      <Routes>
        <Route
          path="/"
          element={<HomeWithSection showPopup={showPopup} setShowPopup={setShowPopup} />}
        />
        <Route
          path="/features"
          element={<HomeWithSection showPopup={showPopup} setShowPopup={setShowPopup} />}
        />
        <Route
          path="/platform"
          element={<HomeWithSection showPopup={showPopup} setShowPopup={setShowPopup} />}
        />
        <Route
          path="/solutions"
          element={<HomeWithSection showPopup={showPopup} setShowPopup={setShowPopup} />}
        />
        <Route
          path="/technology"
          element={<HomeWithSection showPopup={showPopup} setShowPopup={setShowPopup} />}
        />
        <Route
          path="/subscriptions"
          element={<HomeWithSection showPopup={showPopup} setShowPopup={setShowPopup} />}
        />
        <Route
          path="/contact"
          element={<HomeWithSection showPopup={showPopup} setShowPopup={setShowPopup} />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Routes>
    </Router>
  );
}

export default App;
